import * as React from "react";
import {Image, tokens, makeStyles, Button} from "@fluentui/react-components";
import {useEffect} from "react";

const useStyles = makeStyles({
    footer: {
        width: "100%",
        textAlign: "center",
        padding: "10px",
        flexShrink: 0,
    }
});

const Header: React.FC = () => {
    const styles = useStyles();

    const [estConnecte, setEstConnecte] = React.useState(false);

    useEffect(() => {
        setEstConnecte(!!localStorage.getItem("zLawyerToken"));
    }, []);

    const logout = () => {
        localStorage.removeItem("zLawyerToken");
        localStorage.removeItem("zLawyerDemande");
        localStorage.removeItem("zLawyerIdUtilisateur");
        window.location.reload();
    };

    return (
        <section className={styles.footer}>
            {estConnecte && <div>
                <Button onClick={logout}>Déconnexion</Button>
            </div>}
        </section>
    );
};

export default Header;
